import { render, staticRenderFns } from "./DeleteCommentDialog.vue?vue&type=template&id=1ce9da5d&"
import script from "./DeleteCommentDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteCommentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports